import { Injectable } from '@angular/core';
import { Action } from 'src/app/core/models/action.model';
import {
  ClaimsService,
  ClaimWithCase,
} from 'src/app/core/services/claims.service';

@Injectable({
  providedIn: 'root',
})
export class GuideService {
  mainClaim: ClaimWithCase | null = null;

  requirementsFormClaim: Action[] | null = null;

  private skipCheck = false;

  constructor(private claimsService: ClaimsService) {}

  async getMainClaim() {
    if (!this.mainClaim) {
      this.mainClaim = (
        await this.claimsService.getMyClaimsWithCase(1, 0)
      )?.[0];
    }
    return this.mainClaim;
  }

  async checkIfUserMustAccessGuide(): Promise<boolean> {
    if (this.skipCheck || !(await this.getMainClaim())) {
      return false;
    }

    if (!this.requirementsFormClaim) {
      this.requirementsFormClaim =
        await this.claimsService.getRequirementsListForClaimGuide(
          this.mainClaim!.id
        );
      console.log('[GuideService] loadActions', this.requirementsFormClaim);
    }

    const hasCompleteAnyAction =
      !this.requirementsFormClaim ||
      this.requirementsFormClaim.some((a) => a.ac_status != null);

    return !hasCompleteAnyAction;
  }

  resetService() {
    this.mainClaim = null;
    this.requirementsFormClaim = null;
    this.skipCheck = false;
  }

  setSkipCheckTrue() {
    this.skipCheck = true;
  }
}
